module.exports = __webpack_public_path__ + "static/img/wu_hu.8380056e.png";